<template>
  <div class="user-wrapper">
    <div class="content-header-box">
      <a-dropdown>
        <span class="action ant-dropdown-link user-dropdown-menu">
          <span>{{ nickname() }}</span>
        </span>
        <template #slot>
          <a-menu class="user-dropdown-menu-wrapper">
        
            <a-menu-item key="user">
              <router-link :to="{ name: 'backstageChangePassword' }">
                <a-icon type="setting"/>
                <span>修改密码</span>
              </router-link>
            </a-menu-item>
            <a-menu-divider />
            <a-menu-item key="logout">
              <a href="javascript:;" @click="handleLogout">
                <a-icon type="logout"/>
                <span>退出登录</span>
              </a>
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'UserMenu',
  methods: {
    ...mapActions(['Logout']),
    ...mapState({
      nickname: state => state.user.name,
      stype: state => state.user.stype,
    }),
    handleLogout () {
      const that = this;
      that.$modal.confirm({
        title: '提示',
        content: '真的要退出登录吗 ?',
        onOk () {
          return that.Logout().then(() => {
            // 刷新页面，并获得当前Route
            window.location.reload();
            // 不刷新页面，直接指向登录页
            // that.$router.push('/user/login');
          }).catch(err => {
            that.$message.error(`${err}，请稍候再试`);
          });
        },
      });
    }
  }
};
</script>

<style lang="less" scoped>
.user-dropdown-menu-wrapper.ant-dropdown-menu .ant-dropdown-menu-item {
  width: 120px;
}
</style>
